
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HomeEn from "../pages/home/en/page";
import Flanexus from "../pages/flanexus/page";
import FlanexusEn from "../pages/flanexus/en/page";
import News from "../pages/news/page";
import NewsEn from "../pages/news/en/page";
import NewsDetail from "../pages/news/detail/page";
import NewsDetailEn from "../pages/news/en/detail/page";
import Contact from "../pages/contact/page";
import ContactEn from "../pages/contact/en/page";
import AdminPanel from '../pages/admin/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en",
    element: <HomeEn />,
  },
  {
    path: "/flanexus",
    element: <Flanexus />,
  },
  {
    path: "/flanexus/en",
    element: <FlanexusEn />,
  },
  {
    path: "/zh/news",
    element: <News />,
  },
  {
    path: "/en/news",
    element: <NewsEn />,
  },
  {
    path: "/zh/news/detail/:id",
    element: <NewsDetail />,
  },
  {
    path: "/en/news/detail/:id",
    element: <NewsDetailEn />,
  },
  {
    path: "/zh/contact-us",
    element: <Contact />,
  },
  {
    path: "/en/contact-us",
    element: <ContactEn />,
  },
  {
    path: '/admin',
    element: <AdminPanel />
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
